// Module
var code = "<span class=\"odf-text odf-link odf-space-inner-right-s od-float-r od-manage-my-booking-link goToMmbPage\"> {{data.keys.mmbTxt}} </span> ";
// Exports
module.exports = code;